import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router-dom'
import { DEFAULT_SIGN_UP_PATH, getSignUpStep } from '../utils/signup-routing'

/**
 * Restricts signup routes to the steps defined by the application.
 *
 * Validating at the routing boundary keeps signup containers from rendering
 * with an undefined step and gives malformed or stale links a usable fallback.
 */
export function SignUpRoute ({ component: Component, ...routeProps }) {
  return (
    <Route
      {...routeProps}
      render={props => (
        getSignUpStep(props.match.params.currentPage)
          ? <Component {...props} />
          : <Redirect to={`/signup/${DEFAULT_SIGN_UP_PATH}`} />
      )}
    />
  )
}

SignUpRoute.propTypes = {
  component: PropTypes.elementType.isRequired
}
